import { request, storage } from '@bedrock-rdk/utils';
import { MANIFEST_REDIRECT_TIMEOUT_MS } from './player.constants';

/**
 * Operate a GET request on lbCdn url to retrieve real manifest location
 *
 * @async
 * @param {string} lbCdnUrl
 * @returns {Promise<string>} originUrl
 */
export const getOriginUrl = lbCdnUrl => request(lbCdnUrl, { timeout: MANIFEST_REDIRECT_TIMEOUT_MS });

export const getOriginalUrlFromReference = reference => {
  if (reference && reference.includes('no-redirect')) {
    return getOriginUrl(reference);
  }

  return Promise.resolve(reference);
};

export const getUserPreference = (key, profileUid = '') =>
  storage.getItem([profileUid, key].filter(Boolean).join('.') || storage.getItem(key)) || '';

/**
 * Removes a media container created by `createRenderers` (or a media element itself) from the document
 *
 * @param {HTMLElement} container
 */
export const removeSurface = container => {
  if (!container) {
    return;
  }

  while (container.firstChild) {
    container.removeChild(container.lastChild);
  }

  if (container.parentNode) {
    container.parentNode.removeChild(container);
  }
};

export * from './platform/default/player.utils';

export * from './platform/default/playerConfig.utils';
